import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getMedicalConsultSelector } from '../../procedures/medicalConsult/selectors'
import { IMedicalConsultState } from '../../procedures/medicalConsult/store/medicalConsult.types'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { generateClientCorrelationId } from '../../nemsisData/utils/customElements.util'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'

export function* addMedicalConsultItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  const medicalConsultState: IMedicalConsultState = yield select(getMedicalConsultSelector)
  const {
    pta,
    addToTimeline,
    physician,
    otherPhysician,
    method,
    facility,
    key,
    time,
    date,
    assessedBy,
    attempts,
    successfulAttempt,
    comments,
    isEkgImport,
  } = medicalConsultState
  if (addToTimeline) {
    const clientCorrelationId = generateClientCorrelationId(
      nemsisCodeOptions,
      TimelineConstants.MEDICAL_CONSULT_PROCEDURE,
      method?.name || '',
      {
        filter1: null,
        filter2: null,
        filter3: null,
      },
      key
    )
    const successfulAttemptLabel = successfulAttempt ? 'Yes' : 'No'
    const index = items.findIndex((item) => item.key === key)
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }
    const item: IItem = {
      key: key,
      clientCorrelationId,
      grid: true,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      itemType: 'Procedures',
      event: 'Medical Consult',
      eventSubHeader: `By ${assessedBy?.name || ''}, Physician: ${
        physician ? physician.name : otherPhysician
      }, Method: ${method?.name || ''}${facility?.name ? ', Facility: ' + facility.name : ''},
        Attempts: ${attempts}, Success: ${successfulAttemptLabel}, Comments: ${comments}.`,
      rowActionType: TimelineConstants.SET_MEDICAL_CONSULT_PROCEDURE_ITEM,
      defaultHref: TabConstants.MEDICAL_CONSULT_PROCEDURE,
      date: dateTime,
      ...(isEkgImport && { isEkgImport: isEkgImport }),
    }
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addMedicalConsultItemSaga() {
  yield takeLatest([TimelineConstants.ADD_MEDICAL_CONSULT_ITEM], addMedicalConsultItem)
}
